import { useMemo } from "react";

import { useTranslation } from "next-i18next";

import {
  PageTranslations,
  mergePageTranslations,
} from "@/common/utils/i18n-bundles.utils";

/**
 * Keeps the i18n store complete across client-side navigations by merging
 * each page's `_nextI18Next` translations into it (`mergePageTranslations`).
 * Called once, in `_app`, above every component that translates.
 */
export const usePageTranslations = (
  translations: PageTranslations | null | undefined
) => {
  const { i18n } = useTranslation();

  // During render, not in an effect: the page's first `t()` must already find
  // the merged strings. next-i18next's `appWithTranslation` adds resources the
  // same way. The merge is idempotent, so a repeated run is harmless.
  useMemo(() => {
    if (typeof i18n?.addResourceBundle === "function") {
      mergePageTranslations(i18n, translations);
    }
  }, [i18n, translations]);
};
